import React from 'react';
import { Medal } from 'lucide-react';

const Ranking = ({ ranking }) => (
  <div className="bg-slate-900 rounded-3xl border border-slate-800 overflow-hidden shadow-2xl animate-in zoom-in-95 duration-300">
    <div className="p-6 border-b border-slate-800 flex justify-between items-center bg-slate-800/20">
      <div className="flex flex-col"><h3 className="font-black text-sm uppercase tracking-widest text-emerald-500">Official Classification</h3><p className="text-[10px] text-slate-500 font-bold mt-1 uppercase italic tracking-tighter">Wins &gt; Cumulative Balance</p></div>
      <Medal className="w-6 h-6 text-emerald-500/20" />
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-left">
        <thead>
          <tr className="text-slate-500 text-[10px] uppercase tracking-widest border-b border-slate-800 bg-slate-950/50">
            <th className="px-6 py-4 font-black">#</th>
            <th className="px-6 py-4 font-black">Athlete</th>
            <th className="px-6 py-4 font-black text-center text-emerald-400">Wins</th>
            <th className="px-6 py-4 font-black text-right">Balance</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-800/50">
          {ranking.map((row, idx) => (
            <tr key={row.name} className={`${idx === 0 ? 'bg-emerald-500/[0.03]' : ''} hover:bg-slate-800/50 transition-colors`}>
              <td className="px-6 py-5">
                <div className={`w-7 h-7 rounded-xl flex items-center justify-center text-xs font-black 
                  ${idx === 0 ? 'bg-amber-400 text-slate-950 shadow-lg shadow-amber-400/20' : 
                    idx === 1 ? 'bg-slate-300 text-slate-950' : 
                    idx === 2 ? 'bg-orange-500 text-slate-950' : 'text-slate-500 border border-slate-800'}`}>{idx + 1}</div>
              </td>
              <td className="px-6 py-5 font-bold text-slate-200 uppercase tracking-tighter">{row.name}</td>
              <td className="px-6 py-5 text-center font-black text-emerald-400 text-base">{row.wins}</td>
              <td className={`px-6 py-5 text-right font-mono font-black text-lg ${row.points > 0 ? 'text-emerald-400' : row.points < 0 ? 'text-rose-400' : 'text-slate-500'}`}>{row.points > 0 ? `+${row.points}` : row.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default Ranking;
